import React, { FC } from 'react';
import { TCustomHtmlComponentProps } from './types/customHtmlComponent.types';
import { CustomHtmlComponentModel } from './models/customHtmlComponentModel.model';
import DangerouslySetHtmlAndJS from '../@shared/dangerouslySetHtmlAndJS';

const CustomHtml: FC<TCustomHtmlComponentProps> = (props) => {
  const model = new CustomHtmlComponentModel(props);
  const html = model.getInnerHtml?.value || '';

  return <DangerouslySetHtmlAndJS html={html} />;
};
export default CustomHtml;
